import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";

import { WelcomeFormData, welcomeSchema } from "../types/welcome.schema";

type WelcomeFormProps = {
  disabled?: boolean;
};
export function WelcomeForm({ disabled }: WelcomeFormProps) {
  const navigate = useNavigate();
  const form = useForm<z.infer<typeof welcomeSchema>>({
    resolver: zodResolver(welcomeSchema),
    defaultValues: {
      email: "",
    },
  });

  function onSubmit(values: WelcomeFormData) {
    navigate("/sign-up/your-details", {
      state: { email: values.email.toLowerCase().trim() },
    });
  }

  return (
    <div>
      <p className="mb-4 text-base text-secondary">
        Enter your work (organisation) email address to determine if you are
        able to join.
      </p>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Enter your Email</FormLabel>
                <FormControl>
                  <Input
                    placeholder="jim.doe@college.ac.uk"
                    {...field}
                    autoFocus
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="flex justify-between gap-4">
            <Button variant="ghost" asChild>
              <Link to="/sign-in">Return to Login</Link>
            </Button>
            <Button type="submit" disabled={disabled}>
              Begin
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
